<template>
  <div >
    <div class="frame">
    </div>
    <!-- loader -->
    <div class="fill load" v-show="status">
      <div class="container has-text-centered">
        <p class="">
          {{status}}
        </p>
      </div>
    </div>
    <!-- searsh modal -->
    <div class="modal" ref="searchModal">
      <div class="modal-background" @click="$refs.searchModal.classList.remove('is-active')"></div>
      <div class="column" id="geocoder-container" style="min-width:70%;"></div>
      <button class="modal-close is-large" aria-label="close" @click="$refs.searchModal.classList.remove('is-active')"></button>
    </div>
    <div id="mapid" style="height:100%;"></div>
  </div>
</template>
<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import 'mapbox-gl/dist/mapbox-gl.css'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
const Cookies = require('js-cookie')

export default {
  mounted () {
    this.mapBoxInit()
      .then(() => {
        this.getRoutes()

        this.intervalGetMarkers = setInterval(() => this.getRoutes(), 15000)
      })
      .catch(() => {
        console.log('map load error')
      })

    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    clearInterval(this.intervalGetMarkers)
    window.removeEventListener('resize', this.handleResize)

    // remove all map resources
    if (this.mymap) this.mymap.remove()
  },
  data () {
    return {
      position: {
        lng: 0,
        lat: 0,
        rotate: 0
      },
      intervalGetMarkers: null,
      vehicles: {},
      markers: {},
      markersOnScreen: {},
      watchId: null,
      gettPos: false,
      status: '',
      mymap: null,
      touch: true,
      getLocOptions: {
        timeout: 3000,
        enableHighAccuracy: true
      },
      filter: {},
      clusterRadius: 50
    }
  },
  methods: {
    async mapBoxInit () {
      // инициализация карты

      // ждем координат устройства
      // await this.getLocation()

      // set perm city position
      this.position = {
        lat: 57.9980,
        lng: 56.1715,
        rotate: 0
      }

      this.status = 'Загрузка карты...'
      mapboxgl.accessToken = 'pk.eyJ1IjoidmFzaWx5bWFuIiwiYSI6ImNrN2RpeTQxdDBhOGozZG55NHNlOHRwN2kifQ.DNO7wSxhcv6V_AAVseuVMQ'
      try {
        this.mymap = new mapboxgl.Map({
          container: 'mapid',
          style: 'mapbox://styles/vasilyman/ck7dxj3zt00uf1iqu8xpnzrxx',
          center: this.position,
          zoom: 12,
          scrollZoom: true,
          dragPan: this.touch
        })
      } catch (err) {
        return new Promise((resolve, reject) => reject(err))
      }

      // кастомные кнопки управления картой (справа от карты)
      class MyCustomControl {
        onAdd (map) {
          this.map = map
          this.container = document.createElement('div')
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group'
          this.container.innerHTML = `
            <button type="button" id="map-location" title="Моя геопозиция">
              <i class="fas fa-location-arrow"></i>
            </button>
            <button type="button" id="map-search" title="Поиск">
              <i class="fas fa-search"></i>
            </button>
            <button type="button" id="map-interactive" title="Интерактивная карта">
              <i class="fas fa-hand-point-up"></i>
            </button>
          `
          return this.container
        }

        onRemove () {
          this.container.parentNode.removeChild(this.container)
          this.map = undefined
        }
      }

      // кнопки фильтра данных на карте
      class FilterControl {
        onAdd (map) {
          this.map = map
          this.container = document.createElement('div')
          this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group'
          this.container.innerHTML = `
            <button type="button" id="map-filter-med" title="Прошедшие медосмотр">
              <i class="fas fa-heartbeat"></i>
            </button>
            <button type="button" id="map-filter-teh" title="Прошедшие техосмотр">
              <i class="fas fa-wrench"></i>
            </button>
            <button type="button" id="map-filter-clear" title="Сброс фильтра">
              <i class="fas fa-times"></i>
            </button>
          `
          return this.container
        }

        onRemove () {
          this.container.parentNode.removeChild(this.container)
          this.map = undefined
        }
      }

      const geocoder = new MapboxGeocoder({
        accessToken: mapboxgl.accessToken,
        mapboxgl: mapboxgl,
        placeholder: 'Поиск'
      })
      geocoder.on('result', this.mapSearch)
      document.getElementById('geocoder-container').appendChild(geocoder.onAdd(this.mymap))

      // устанавливаем все кнопки управления картой
      this.mymap.addControl(new mapboxgl.NavigationControl())
      this.mymap.addControl(new mapboxgl.FullscreenControl())
      this.mymap.addControl(new mapboxgl.ScaleControl())
      this.mymap.addControl(new MyCustomControl())
      this.mymap.addControl(new FilterControl(), 'top-left')

      // огда карта загружена и готова
      await new Promise(resolve => {
        this.mymap.on('load', () => {
          this.status = ''

          // действия кнопок управления картой (кастомные)
          const elLoc = document.getElementById('map-location')
          elLoc.addEventListener('click', this.findMe)
          const elSrch = document.getElementById('map-search')
          elSrch.addEventListener('click', this.mapSearch)
          const elInt = document.getElementById('map-interactive')
          elInt.classList.toggle('has-background-grey-lighter', !this.touch)
          elInt.classList.toggle('has-text-success', this.touch)
          elInt.addEventListener('click', this.touched)

          const elMed = document.getElementById('map-filter-med')
          elMed.addEventListener('click', this.filterMed)
          const elTeh = document.getElementById('map-filter-teh')
          elTeh.addEventListener('click', this.filterTeh)
          const elClear = document.getElementById('map-filter-clear')
          elClear.classList.toggle('has-text-danger', this.$_.intersection(Object.keys(this.filter), ['med', 'teh']).length > 0)
          elClear.addEventListener('click', this.filterClear)

          // обработчик перемещений карты
          this.addGeoJSON()

          this.mymap.addLayer({
            id: 'cluster-cars-count-background',
            source: 'earthquakes',
            type: 'circle',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': [
                'case',
                ['==', ['get', 'osmotr'], true],
                'hsl(141, 71%, 48%)',
                ['==', ['get', 'osmotr'], false],
                'hsl(348, 100%, 61%)',
                'hsl(0, 0%, 48%)'
              ],
              'circle-opacity': 0.6,
              'circle-radius': 16
            }
          })

          this.mymap.addLayer({
            id: 'cluster-cars-count',
            source: 'earthquakes',
            type: 'symbol',
            filter: ['has', 'point_count'],
            layout: {
              'text-field': [
                'number-format',
                ['get', 'point_count_abbreviated'],
                { 'min-fraction-digits': 0, 'max-fraction-digits': 0 }
              ],
              'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
              'text-size': 14
            }
          })

          // inspect a cluster on click
          this.mymap.on('click', 'cluster-cars-count-background', (e) => {
            console.log('click cluser')
            const features = this.mymap.queryRenderedFeatures(e.point, {
              layers: ['cluster-cars-count-background']
            })
            const clusterId = features[0].properties.cluster_id
            this.mymap.getSource('earthquakes').getClusterExpansionZoom(
              clusterId,
              (err, zoom) => {
                if (err) return

                this.mymap.easeTo({
                  center: features[0].geometry.coordinates,
                  zoom: zoom
                })
              }
            )
          })
          this.mymap.on('mouseenter', 'cluster-cars-count-background', () => {
            this.mymap.getCanvas().style.cursor = 'pointer'
          })
          this.mymap.on('mouseleave', 'cluster-cars-count-background', () => {
            this.mymap.getCanvas().style.cursor = ''
          })

          this.mymap.on('moveend', this.updateMarkers)

          this.mymap.on('data', (e) => {
            if (e.sourceId !== 'earthquakes') return
            this.updateMarkers()
          })

          return resolve()
        })
      })
      console.log('карта загружена')
    },
    filterMed () { this.filterSet('med', 'toggle') },
    filterTeh () { this.filterSet('teh', 'toggle') },
    filterClear () {
      //
      this.filterSet('med', 'delete')
      this.filterSet('teh', 'delete')
    },
    filterSet (filterType, action) {
      // устанавливаем значения переменной фильтра
      if (action === 'toggle') {
        if (filterType in this.filter) {
          if (this.filter[filterType] === true) this.filter[filterType] = false; else this.$delete(this.filter, filterType)
        } else this.filter[filterType] = true
      } else if (action === 'delete') {
        this.$delete(this.filter, filterType)
      } else this.filter[filterType] = action

      // меняем цвет иконок
      const el = document.getElementById(`map-filter-${filterType}`)
      el.classList.toggle('has-text-danger', filterType in this.filter && !this.filter[filterType])
      el.classList.toggle('has-text-success', filterType in this.filter && this.filter[filterType])

      const el1 = document.getElementById('map-filter-clear')
      el1.classList.toggle('has-text-danger', this.$_.intersection(Object.keys(this.filter), ['med', 'teh']).length > 0)

      // применяем фильтр к данным
      this.filterViewedVehicles()
    },
    filterViewedVehicles () {
      // применяем фильтр к отображаемым маркерам
      let vehiclesViewed = {}
      const vehicles = this.vehicles
      if ('med' in this.filter && 'teh' in this.filter) {
        vehiclesViewed = this.$_.filter(vehicles, { properties: { medosmotr: this.filter.med, tehosmotr: this.filter.teh } })
      } else if ('med' in this.filter && !('teh' in this.filter)) {
        vehiclesViewed = this.$_.filter(vehicles, { properties: { medosmotr: this.filter.med } })
      } else if (!('med' in this.filter) && 'teh' in this.filter) {
        vehiclesViewed = this.$_.filter(vehicles, { properties: { tehosmotr: this.filter.teh } })
      } else {
        vehiclesViewed = vehicles
      }
      // set data
      this.mymap.getSource('earthquakes').setData({
        type: 'FeatureCollection',
        features: vehiclesViewed
      })
    },
    addGeoJSON () {
      // add a clustered GeoJSON source for a sample set of earthquakes
      this.mymap.addSource('earthquakes', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: []
        },
        cluster: true,
        clusterRadius: this.clusterRadius,
        clusterProperties: {
          // keep separate counts for each magnitude category in a cluster
          osmotr: ['all', ['get', 'medosmotr'], ['get', 'tehosmotr']]
        }
      })
    },
    touched (e) {
      // переключает интерактивность карты (возможность перемещения карты мышкой)
      if (this.touch) this.mymap.dragPan.disable(); else this.mymap.dragPan.enable()
      if (e) {
        const elInt = document.getElementById('map-interactive')
        elInt.classList.toggle('has-background-grey-lighter')
        elInt.classList.toggle('has-text-success')
      }
      this.touch = !this.touch
    },
    mapSearch () {
      // переключает видимость модальное окно поиска
      console.log('map search window toggle')
      this.$refs.searchModal.classList.toggle('is-active')
    },
    async getRoutes () {
      // получает список транспорта и маршрутов, объединяет в один массив
      const csrftoken = Cookies.get('csrftoken')
      let vehicles = null
      let routes = null
      let res = null

      const vehiclesUrl = 'http://www.map.gptperm.ru/json/uvb/getVehiclesInDistrict?vehicleTypeIds=5+15+21+3+8+4+13+6+20+10+1+12+2+7+17+9+19+16+14+11+18'

      // получаем список транспорта:
      res = await this.$axios.post('/cors/', { url: vehiclesUrl }, { headers: { 'x-csrftoken': csrftoken } })
      vehicles = res.data.vehicles

      const regs = []
      const params = {
        search: regs
      }
      // получаем инфу для полученного транспорта об осмотрах:
      res = await this.$axios.get('/routes/', { params })
      routes = res.data.results

      await new Promise((resolve, reject) => {
        try {
          // складываем данные в один массив:
          vehicles = vehicles.map(vehicle => {
            const route = routes.find(route => {
              const r = new RegExp(vehicle.licencePlate.replace(' ', ''), 'i')
              return r.test(route.registration.replace(' ', ''))
            })
            if (route !== undefined) {
              vehicle = Object.assign(vehicle, route)
              // console.log(vehicle)
            }
            return vehicle
          })

          // создаем список маркеров (ПЕРЕДЕЛАТЬ В GEOJSON):
          this.vehicles = vehicles.map(vehicle => {
            // вычленяем данные
            const r = /\((.*)\)/
            const coord = vehicle.location.match(r)[1]
            const registration = vehicle.licencePlate
            const longitude = coord.split(' ')[0]
            const latitude = coord.split(' ')[1]
            const rotation = vehicle.course
            const id = vehicle.vehicleId
            const medosmotr = !!vehicle.medosmotr
            const tehosmotr = !!vehicle.tehosmotr
            const title = vehicle.vehicleTypeName
            const description = `
              <h3>${vehicle.vehicleTypeName}</h3>
              <p>${vehicle.licencePlate}, ${coord}</p>
              <p class="has-text-${medosmotr ? 'success' : 'danger'}">Медосмотр ${medosmotr ? 'пройден' : 'не пройден'}</p>
              <p class="has-text-${tehosmotr ? 'success' : 'danger'}">Техосмотр ${tehosmotr ? 'пройден' : 'не пройден'}</p>
            `

            // устанавливаем свойства
            const properties = {
              id,
              registration,
              title,
              description,
              medosmotr,
              tehosmotr,
              rotation
            }
            const geometry = {
              type: 'Point',
              coordinates: [
                longitude,
                latitude
              ]
            }

            return {
              type: 'Feature',
              properties,
              geometry
            }
          })

          // применяем фильтр к данным
          this.filterViewedVehicles()

          console.log('get routes')

          resolve()
        } catch (error) {
          this.status = 'ошибка загрузги объектов'
          console.log(error)
          reject(error)
        }
      })
    },
    markerElement (props) {
      // элемент маркера
      const el = document.createElement('div')
      el.className = ' '
      el.style = 'z-index:0;cursor:pointer;position:absolute;'
      el.title = props.title
      let icon = 'car-side'
      switch (props.title) {
        case 'Погрузчик':
        case 'Минипогрузчик':
          icon = 'truck-moving'
          break
        case 'КДМ':
        case 'Бульдозер':
          icon = 'snowplow'
          break
        case 'Грузовик':
        case 'Самосвал':
          icon = 'truck'
          break
        case 'Трактор':
          icon = 'tractor'
          break
        case 'Вахта':
          icon = 'shuttle-van'
          break
        default:
          icon = 'car-side'
          break
      }
      el.innerHTML = `
        <i
          class="i-car fas fa-lg fa-${icon}"
          id="${props.id}"
          style="transform:rotate(${props.rotation - this.mymap.getBearing() - 90}deg);"
        ></i>
        <div style="position:absolute;transform: translateX(-50%);left:50%;bottom:100%;white-space:nowrap;">
          <div style="text-align:center;">
            <i
              class="i-teh fas fa-wrench fa-lg ${props.tehosmotr ? 'has-text-success' : 'has-text-danger'}"
              title="Техосмотр"
            ></i>
            <i class="i-med fas fa-heartbeat fa-lg ${props.medosmotr ? 'has-text-success' : 'has-text-danger'}" title="Медосмотр"></i>
          </div>
          <span >${props.registration}</span>
        </div>
      `
      return el
    },
    updateMarkers () {
      const newMarkers = {}
      const features = this.mymap.querySourceFeatures('earthquakes')
      // Для каждого кластера на экране создайте для него HTML-маркер (если мы этого еще не сделали),
      // и добавляем его на карту, если его там нет
      for (let i = 0; i < features.length; i++) {
        const coords = features[i].geometry.coordinates
        const props = features[i].properties

        if (props.cluster) continue

        // const id = props.cluster_id
        const id = props.id

        let marker = this.markers[id]

        // create the popup:
        const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(props.description)

        // обновляем маркеры
        if (marker) {
          const markEl = marker.getElement()
          marker.setLngLat(coords)
          // rotate marker
          markEl.getElementsByClassName('i-car')[0].style.transform = `rotate(${props.rotation - this.mymap.getBearing() - 90}deg)`
          // set colors status
          const iTehEl = markEl.getElementsByClassName('i-teh')[0]
          iTehEl.classList.toggle('has-text-success', props.tehosmotr)
          iTehEl.classList.toggle('has-text-danger', !props.tehosmotr)
          const iMedEl = markEl.getElementsByClassName('i-med')[0]
          iMedEl.classList.toggle('has-text-success', props.medosmotr)
          iMedEl.classList.toggle('has-text-danger', !props.medosmotr)
          // update popup
          marker.setPopup(popup)
        }

        if (!marker) {
          var el = this.markerElement(props)

          marker = this.markers[id] = new mapboxgl.Marker({
            element: el
          }).setPitchAlignment('auto').setLngLat(coords).setPopup(popup)
        }
        newMarkers[id] = marker

        if (!this.markersOnScreen[id]) marker.addTo(this.mymap)
      }
      // Для каждого добавленного ранее маркера удалите те, которые больше не актуальны
      for (const id in this.markersOnScreen) {
        if (!newMarkers[id]) this.markersOnScreen[id].remove()
      }
      this.markersOnScreen = newMarkers
      console.log('update markers')
    },
    async findMe () {
      await this.getLocation()
      this.setView(this.position)
    },
    setView (LonLat) {
      if (!('lng' in LonLat && 'lat' in LonLat)) return
      // console.log()
      this.mymap.rotateTo(parseFloat(LonLat.rotate)).flyTo({
        center: [parseFloat(LonLat.lng), parseFloat(LonLat.lat)],
        essential: true
      })
    },
    watchPos () {
      this.status = 'Поиск геолокации'
      if (!navigator.geolocation) {
        this.status = 'GPS геолокация недоступна'
      } else {
        const success = (position) => {
          this.status = ''
          this.position.lat = position.coords.latitude
          this.position.lng = position.coords.longitude
          this.position.rotate = 'heading' in position.coords ? position.coords.heading || 0 : 0
          this.setView(this.position)
        }
        const error = () => {
          this.status = 'Ошибка GPS геолокации'
          setTimeout(() => { this.status = '' }, 1000)
          this.stopWatchPos()
        }
        this.watchId = navigator.geolocation.watchPosition(success, error, this.getLocOptions)
      }
    },
    stopWatchPos () {
      if (this.watchId) navigator.geolocation.clearWatch(this.watchId)
      this.watchId = null
    },
    async getLocation () {
      this.gettPos = true
      this.status = 'Поиск геолокации...'
      const getPosition = (options) => {
        return new Promise(function (resolve, reject) {
          navigator.geolocation.getCurrentPosition(resolve, reject, options)
        })
      }
      if (navigator.geolocation) {
        this.status = 'GPS геолокация...'
        await getPosition(this.getLocOptions)
          .then(position => {
            this.position.lat = position.coords.latitude
            this.position.lng = position.coords.longitude
            this.position.rotate = 'heading' in position.coords ? position.coords.heading || 0 : 0
            this.gettPos = false
            this.status = ''
          })
          .catch(err => {
            this.status = err.message
          })
      }
      if (this.status === '') return
      await this.getLocIp()
        .then(() => {
          this.status = ''
        })
        .catch(err => {
          this.status = err.message
          // set moscow coord  55.751244, 37.618423
          this.position.lat = 55.751244
          this.position.lng = 37.618423
        })
      this.gettPos = false
    },
    async getLocIp () {
      this.status = 'Геолокация по IP...'
      await this.$axios.get('https://ipinfo.io?token=4e18dbd6fa5abf')
        .then(res => {
          const data = res.data.loc.split(',')
          this.position.lat = data[0]
          this.position.lng = data[1]
        })
    },
    handleResize () {
      // задержка для анимации переворачивания, делаем небольшую задержку перед ресайзом карты
      setTimeout(() => this.mymap.resize(), 200)
    }
  }
}
</script>
<style lang="scss" scoped>
  // #mapid {
  //   height: 100%;
  // }
  .frame {
    position: fixed;
    margin: 1rem;
    width: 320px;
    top: 52px;
    z-index: 1;
  }
  .load {
    display: flex;
    align-items: center;
    flex-grow: 1;
    z-index: 1;
    background-color: rgba($color: #ffffff, $alpha: 0.5)
}
  .mapboxgl-ctrl-geocoder {
    min-width: 100%;
  }
</style>
